import { render, staticRenderFns } from "./SequenceMetadata.vue?vue&type=template&id=36f29f38&scoped=true"
import script from "./SequenceMetadata.vue?vue&type=script&lang=js"
export * from "./SequenceMetadata.vue?vue&type=script&lang=js"
import style0 from "./SequenceMetadata.vue?vue&type=style&index=0&id=36f29f38&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f29f38",
  null
  
)

export default component.exports